{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              56.22443380221583,
              26.51840826445752
            ],
            [
              51.56976184286282,
              24.421171623322124
            ],
            [
              51.552983663028215,
              24.023345646972615
            ],
            [
              52.54289627333449,
              22.892093366769487
            ],
            [
              55.118346878116796,
              22.64456118657033
            ],
            [
              55.823030431216836,
              24.901476669607348
            ],
            [
              56.368321275877406,
              24.977545024254056
            ],
            [
              56.37671036579653,
              25.62221726919904
            ],
            [
              56.15859402793228,
              25.637344607230247
            ],
            [
              56.09987039850759,
              26.060129008865772
            ],
            [
              56.22443380221583,
              26.51840826445752
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}